const messages = {
  title: "Zgody marketingowe",
  required: "Wymagane",
  answered: "✓ Odpowiedziano",
  read: "Przeczytane",
  notRead: "Nieprzeczytane",
  alreadyAnswered: "Już udzielono odpowiedzi",
  requiredQuestionsMustBeAccepted: "Należy zaakceptować {count} wymagane pytanie{plural}",
  pleaseAnswerQuestions: "Odpowiedz na poniższe pytania:",
  iAccept: "Akceptuję",
  scrollToUnlock: "Przewiń do końca, aby odblokować",
  fieldRequired: "To pole jest wymagane",
  scrollToContinue: "↓ Przewiń do końca, aby kontynuować",
  saving: "Zapisywanie...",
  saveConsents: "Zapisz zgody",
  allRequiredAccepted: "✓ Wszystkie wymagane pytania zaakceptowane",
  requiredConsentsCompleted: "{completed}/{total} wymaganych zgód zostało uzupełnionych",
  selectConsentToView: "Wybierz zgodę z listy, aby wyświetlić jej treść",
  readAllContentFirst: "Najpierw przeczytaj całą treść: {names}",
  acceptAllRequiredIn: "Zaakceptuj wszystkie wymagane pytania w: {names}",
  acceptAllBeforeSaving: "Przed zapisem zaakceptuj wszystkie wymagane pytania.",
  failedToSave: "Nie udało się zapisać zgód. Spróbuj ponownie.",
  errorSaving: "Wystąpił błąd podczas zapisywania zgód. Spróbuj ponownie.",
  failedToLoad: "Nie udało się wczytać zgód. Odśwież stronę.",
  viewPdf: "Pobierz PDF",
  requiredConsentTitle: "Wymagana zgoda",
  acceptAndContinue: "Akceptuj i kontynuuj",
};

export default {
  messages,
};
